import { useMemo } from "react";

import { keyOf, NameAndCreateDateFormatter } from "@Components/Grid/components/Table/formatters";
import { defaultColumnId, defaultColumn, defaultActionsColumn, deleteAction, editAction } from "@Components/Grid/utils/column";

import EditBlockEntity from "./EditBlockEntity";
import LevelFormatter from "./LevelFormatter";
import UserFormatter from "./UserFormatter";

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn("name", "Description", info => <NameAndCreateDateFormatter info={info} />, { initialSize: "max-w-[20vw]" }),
    defaultColumn("user", "User", info => <UserFormatter info={info} />, { enableSorting: false }),
    defaultColumn("level", "Level", info => <LevelFormatter info={info} />),
    defaultActionsColumn(editAction, editBlockAction, deleteAction),
  ], [])
}

function editBlockAction(info) {
  return <EditBlockEntity key={keyOf(info, 'edit-block')} info={info} />
}
